import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { CadastrarVoucherModalComponent } from '../modals/cadastrar-voucher-modal/cadastrar-voucher-modal.component';
import { VoucherService } from '../services/voucher.service';
import { VoucherAutomaticoService } from '../services/voucher-automatico.service';
import { Voucher } from '../models/voucher';
import swal from 'sweetalert2';

declare const $: any;

@Component({
  selector: 'app-vouchers-genericos',
  templateUrl: './vouchers-genericos.component.html',
  styleUrls: ['./vouchers-genericos.component.scss']
})
export class VouchersGenericosComponent implements OnInit {

  vouchers: Voucher[] = [];

  constructor(
    private dialog: MatDialog,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private voucherService: VoucherService,
  ) { }

  ngOnInit(): void {
    this.buscarVouchersGenericos();
  }

  buscarVouchersGenericos() {
    this.carregandoService.mostra('buscarVouchersGenericos');

    this.voucherService.consultarGenericos().subscribe(
      vouchers => {
        this.vouchers = vouchers;
        this.carregandoService.esconde('buscarVouchersGenericos');
      },
      err => {
        this.carregandoService.esconde('buscarVouchersGenericos');
        this.notificacaoService.erro(err);
      });
  }

  novoVoucher() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarVoucherModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {

      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) { this.buscarVouchersGenericos(); }
    });
  }

  cancelarVoucher(voucher: Voucher) {
    swal({
      title: 'Deseja realmente cancelar este Voucher?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('cancelarVoucher');

        this.voucherService.cancelar(voucher.id).subscribe(
          () => {
            this.carregandoService.esconde('cancelarVoucher');
            this.buscarVouchersGenericos();
          },
          err => {
            this.carregandoService.esconde('cancelarVoucher');
            this.notificacaoService.erro(err);
          }
        );
      }
    });

  }
}
